<template>
  <div>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <h3>ตารางรายละเอียดติดตั้งแต่ละจุด</h3>
      </b-col>
      <b-col
        lg="4"
        md="4"
        class="d-flex align-items-center justify-content-start mb-1"
      >
        <label>ค้นหา</label>
        <b-input-group
          size="sm"
          style="padding-left:14px;"
        >
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="ป้อนคำค้นหา"
            label-cols-sm="12"
            label-cols-md="2"
            label-cols-lg="2"
            style=" background-color:rgba(0,0,0, 0.6);"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              ล้าง
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(index)="data">
            {{ data.index +1 }}
          </template>
          <template #cell(live)="data">
            <b-link
              v-b-modal="'Live'"
              @click="$refs.RTSP.streamLive(data.item.RTSP_HLS)"
            >
              <b-img
                src="@/assets/images/icons/Live.svg"
              />
            </b-link>
          </template>
          <template #cell(ISOnline)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(edit)="data">
            <b-link
              v-b-modal="'modalEdit'"
              @click="$refs.childref.sendInfo(data.item.ipaddress)"
            >
              <b-img
                src="@/assets/images/icons/Edit.svg"
              />
            </b-link>
          </template>
        </b-table>
      </b-col>
      <b-col
        cols="12"
      >
        <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
          <!-- page length -->
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
    <Live
      ref="RTSP"
    />
    <!-- MODAL EDIT -->
    <CCTVEdit
      ref="childref"
      @fetch="getTableCCTV()"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BPagination, BInputGroup, BInputGroupAppend, BFormInput, BButton,
  BFormGroup, BFormSelect, BCardBody, BLink, BImg, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import Live from './Live.vue'
import CCTVEdit from './CCTVEdit.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BFormGroup,
    BFormSelect,
    BCardBody,
    BLink,
    BImg,
    BBadge,
    Live,
    CCTVEdit,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      fields: [
        {
          key: 'num_pole',
          label: 'ลำดับ',
          sortable: true,
        },
        {
          key: 'Camera_Desc',
          label: 'ตำแหน่ง',
          sortable: false,
        },
        {
          key: 'live',
          label: 'Live',
        },
        {
          key: 'ISOnline',
          label: 'สถานะ',
        },
        {
          key: 'edit',
          label: 'การจัดการ',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        Online: 'Online', Offline: 'Offline',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fieldsSpeaker
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getTableCCTV()
    this.interval = setInterval(() => {
      this.getTableCCTV()
    }, 300000)
  },
  methods: {
    getTableCCTV() {
      axios
        .post('/getTableCCTVDetail', { wid: this.$route.query.wid, username: this.userData.username })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
